export default __webpack_public_path__ + "static/media/happy.c34e85cf.svg";